import { useEffect, useState } from "react";
import { getSyncMode, SYNC_MODE_EVENT } from "../lib/noteEngineState";
import { isDbReady } from "../lib/sqlite";

/** Whether this device syncs note text in legacy mode (PLAN.md D8). */
export function useLegacySyncMode(): boolean {
  const [legacy, setLegacy] = useState(() => isDbReady() && getSyncMode() === "legacy");
  useEffect(() => {
    const update = () => setLegacy(isDbReady() && getSyncMode() === "legacy");
    update();
    window.addEventListener(SYNC_MODE_EVENT, update);
    return () => window.removeEventListener(SYNC_MODE_EVENT, update);
  }, []);
  return legacy;
}
